import React from "react";
import { Link } from "react-router-dom";
import { SITE } from "@/data/site";
import { Gonjong, Stamp } from "@/components/Gonjong";

const FACTS = [
  {
    title: "Digagas Arief Muhammad",
    desc: "Berawal dari tantangan Wakil Gubernur Sumatera Barat, Audy Joinaldy, untuk membuka bisnis kuliner khas Minangkabau.",
  },
  {
    title: "Diresmikan 24 Juli 2022",
    desc: "Peresmian dilakukan langsung oleh Wakil Gubernur Sumatera Barat, Audy Joinaldy.",
  },
  {
    title: "Beras Solok",
    desc: "Nasi kami dimasak dari beras Solok — salah satu beras terbaik yang berasal dari Sumatera Barat.",
  },
  {
    title: SITE.tagline,
    desc: "Tagline kami dalam bahasa Minang: memang sungguh lamak (lezat). Janji rasa yang kami jaga di setiap dapur outlet.",
  },
];

const Tentang = () => (
  <main data-testid="tentang-page">
    <section className="relative bg-ijo text-rice">
      <div className="mx-auto max-w-6xl px-4 pb-20 pt-16 sm:px-6 sm:pt-20">
        <p className="text-sm font-bold uppercase tracking-[0.22em] text-kunyit">
          Tentang Kami
        </p>
        <h1
          data-testid="tentang-h1"
          className="mt-3 max-w-2xl font-display text-4xl font-black leading-tight sm:text-5xl"
        >
          Menjaga masakan Padang tetap di hati
        </h1>
      </div>
      <div className="absolute bottom-0 left-0 right-0 text-rice">
        <Gonjong />
      </div>
    </section>

    <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
      <div className="grid items-start gap-12 md:grid-cols-[1.15fr_1fr]">
        <div className="space-y-5 text-base leading-relaxed text-ink/80 sm:text-lg">
          <p>
            Masakan Padang sudah mendunia — dan bagi orang Minangkabau, menjaga
            rasanya adalah sebuah kewajiban. {SITE.name} lahir dari semangat
            itu: sebuah rumah makan yang digagas oleh Arief Muhammad setelah
            menerima tantangan dari Wakil Gubernur Sumatera Barat, Audy
            Joinaldy, untuk membuka bisnis kuliner khas Minangkabau.
          </p>
          <p>
            Rumah makan ini diresmikan pada 24 Juli 2022 dengan nama{" "}
            <strong>Padang Payakumbuah</strong> dan tagline{" "}
            <strong>{SITE.tagline}</strong> — dalam bahasa Minang, kurang lebih
            berarti “memang sungguh lezat”.
          </p>
          <p>
            Cita rasa otentik kami jaga mulai dari bahan: nasi dimasak dari
            beras Solok, santan dan cabai diracik sebagaimana dapur Minang
            memasaknya. Hasilnya adalah hidangan yang kami banggakan — rendang,
            dendeng batokok lado merah, ayam pop, hingga teh talua dan es
            durian.
          </p>
          <p>
            {SITE.name} dikelola oleh {SITE.company} dan kini hadir di berbagai
            kota.{" "}
            <Link
              to="/lokasi/"
              data-testid="tentang-lokasi-link"
              className="font-bold text-lado underline-offset-4 hover:underline"
            >
              Temukan outlet terdekat
            </Link>{" "}
            atau{" "}
            <Link
              to="/menu/"
              data-testid="tentang-menu-link"
              className="font-bold text-lado underline-offset-4 hover:underline"
            >
              lihat menu kami
            </Link>
            .
          </p>
        </div>
        <div className="relative">
          <div className="absolute -left-3 -top-3 h-full w-full rounded-2xl border-2 border-kunyit" aria-hidden="true" />
          <img
            src="/images/hero-hidangan.jpg"
            alt="Etalase hidangan masakan Padang di rumah makan"
            width="1280"
            height="720"
            loading="lazy"
            className="relative w-full rounded-2xl object-cover shadow-xl"
          />
          <Stamp className="absolute -bottom-6 -left-4 bg-rice/90" />
        </div>
      </div>

      <div className="mt-20 grid gap-5 sm:grid-cols-2" data-testid="tentang-facts">
        {FACTS.map((f) => (
          <div
            key={f.title}
            className="rounded-2xl border border-ink/10 bg-card p-7"
          >
            <h2 className="font-display text-xl font-bold text-lado">{f.title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-ink/75 sm:text-base">
              {f.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  </main>
);

export default Tentang;
